<div class="accordion mb-2" id="widget-options">
  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#widget-options-one"
        aria-expanded="false" aria-controls="widget-options-one">
        Options
      </button>
    </h2>
    <div id="widget-options-one" class="accordion-collapse collapse" data-bs-parent="#widget-options">
      <div class="accordion-body">
        <div class="d-flex flex-wrap options-container">
          <ng-container #optionsContainer></ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col">
    <label class="form-label">Preview country</label>
    <input type="text" class="form-control" [(ngModel)]="country"
      [ngModelOptions]="{standalone: true}" (change)="loadWidget()">
  </div>
  <div class="col-auto d-flex">
    <button class="btn btn-primary align-self-end" (click)="refresh()" type="button">Refresh</button>
  </div>
</div>
<div class="w-100 position-relative mt-3">
  <iframe #iframe width="100%"></iframe>
  @if (loading) {
    <div class="widget-loader">
      <div class="d-flex align-items-center justify-content-center h-100">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  }
</div>
